import type { ComponentId } from '../game/components';

export const PALETTE = {
  void:  '#0d0b14',
  stone: '#3a3344',
  ember: '#ff5a3c',
  frost: '#4db8ff',
  venom: '#6ee86e',
  volt:  '#ffd84d',
  inert: '#6b6570',
  text:  '#e8e2f0',
  dim:   '#8a8298',

  // UI chrome
  panel:      '#16131f',
  panelEdge:  '#2c2738',
  wellLip:    '#4a4258',
  wellPit:    '#100d18',
  hp:         '#e8484f',
  hpBack:     '#3a1f26',
  block:      '#5ec8e8',
  poison:     '#7dd84f',
  gold:       '#e8c45a',
  danger:     '#ff3b3b',
  good:       '#6ee86e',

  rarityCommon:   '#7a7488',
  rarityUncommon: '#4db8ff',
  rarityRare:     '#e8c45a',
} as const;

export type PaletteKey = keyof typeof PALETTE;

/** Gem body color per kind. Stone is deliberately matte. */
export const GEM_COLOR = {
  ember: PALETTE.ember,
  frost: PALETTE.frost,
  venom: PALETTE.venom,
  volt:  PALETTE.volt,
  stone: PALETTE.inert,
} as const;

/** Single-character glyph used in debug dumps and intent text. */
export const GEM_GLYPH = {
  ember: 'E',
  frost: 'F',
  venom: 'V',
  volt: 'L',
  stone: 'S',
} as const;

/** Icon tint per crafting component. Shares the gem hues where identity allows. */
export const COMPONENT_COLOR: Record<ComponentId, string> = {
  ember_fragment: PALETTE.ember,
  frost_crystal: PALETTE.frost,
  venom_component: PALETTE.venom,
  volt_component: PALETTE.volt,
  masonry_fragment: PALETTE.inert,
  prism_dust: '#b57aff',
  impact_core: PALETTE.gold,
};
